import {
  useState,
  useEffect,
} from "react";

import {
  Card,
  Row,
  Col,
  Typography,
  Select,
  InputNumber,
  Space,
  Image,
  Tag,
  AutoComplete,
  Button,
  Input,
  Popconfirm,
} from "antd";

import {
  DeleteOutlined,
  SwapOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import calculateHotelTotals
  from "../../utils/calculateHotelTotals";

import getHotelRate
  from "../../utils/getHotelRate";

const { Text, Title } =
  Typography;

const HotelCard = ({
  lead,
  hotel,
  index,
  day,
  updateDay,
  searchHotels,
}) => {

const [
  editingHotel,
  setEditingHotel,
] = useState(
  !hotel.name
);

  const [
    hotelSearch,
    setHotelSearch,
  ] = useState(
    hotel.name || ""
  );

  const [
    hotelResults,
    setHotelResults,
  ] = useState([]);

  /* =====================================================
     SEARCH HOTELS
  ===================================================== */

  useEffect(() => {

    if (
      !editingHotel ||
      !hotelSearch
    ) {
      return;
    }

    const timer =
      setTimeout(async () => {

        try {

          const destParam = Array.isArray(lead?.destinations) && lead.destinations.length
            ? lead.destinations.map(d => d.name || d.city || d).join(",")
            : (lead?.destination?.name || lead?.destination?.city || lead?.destination || "");

          const response =
            await searchHotels(
              hotelSearch,
              day.date,
              lead?._id || null,
              destParam
            );

setHotelResults(
  Array.isArray(
    response?.data?.data
  )
    ? response.data.data
    : []
);

        } catch (err) {

          console.error(
            "HOTEL SEARCH ERROR:",
            err
          );
        }

      }, 400);

    return () =>
      clearTimeout(timer);

  }, [
    hotelSearch,
    editingHotel,
    searchHotels,
  ]);

  /* =====================================================
     UPDATE HOTEL
  ===================================================== */

const updateHotel = (
  changes,
  skipAutoTotal = false
) => {
  const updated = [...day.hotels];

  updated[index] = {
    ...updated[index],
    ...changes,
  };

  if (!skipAutoTotal) {
    const pricing = calculateHotelTotals(updated[index]);

    updated[index].pricing = pricing;
    updated[index].total = pricing.finalTotal;
  }

  updateDay(day.id, {
    hotels: updated,
  });
};

  /* =====================================================
     REMOVE HOTEL
  ===================================================== */

  const removeHotel = () => {

    const updated =
      [...day.hotels];

    updated.splice(index, 1);

    updateDay(day.id, {
      hotels: updated,
    });
  };

  /* =====================================================
     CHANGE HOTEL
  ===================================================== */

  const changeHotel =
    (selectedHotel) => {

      const firstRoom =
        selectedHotel
          ?.roomOptions?.[0];

      const firstMeal =
        firstRoom
          ?.mealPlans?.[0];

      const rates =
        firstMeal
          ?.rates || {};

      const updated =
        [...day.hotels];

      updated[index] = {

        ...updated[index],

        hotelId:
          selectedHotel._id,

        name:
          selectedHotel.name,

        city:
          selectedHotel
            ?.location?.city || "",

image:

  selectedHotel?.image ||

  selectedHotel?.heroImage ||

  selectedHotel?.images?.find(
    (img) => img?.isPrimary
  )?.url ||

  selectedHotel?.images?.[0]?.url ||

  selectedHotel?.images?.[0]?.image ||

  (
    typeof selectedHotel?.images?.[0]
      === "string"

      ? selectedHotel.images[0]

      : ""
  ) ||

  "",

images:
    selectedHotel?.images || [],

        roomOptions:
          selectedHotel
            ?.roomOptions || [],

        mealOptions:
          firstRoom
            ?.mealPlans || [],

roomType:
  firstRoom
    ?.roomCategory || "",

roomCategory:
  firstRoom
    ?.roomCategory || "",

mealPlan:
  firstMeal
    ?.mealPlan || "CP",

rooms: 1,

checkIn:
  day.date
    ? new Date(day.date)
        .toISOString()
        .split("T")[0]
    : "",

checkOut:
  day.date
    ? (() => {

        const d =
          new Date(day.date);

        d.setDate(
          d.getDate() +
          Number(
            updated[index]
              ?.nights || 1
          )
        );

        return d
          .toISOString()
          .split("T")[0];
      })()
    : "",

        basePrice:
          rates.baseRate || 0,

        extraAdultPrice:
          rates.extraAdultRate || 0,

        cwbPrice:
          rates.childWithBedRate || 0,

        cnbPrice:
          rates.childNoBedRate || 0,
      };

const pricing =
  calculateHotelTotals(
    updated[index]
  );

updated[index].pricing =
  pricing;

updated[index].total =
  pricing.finalTotal;

      updateDay(day.id, {
        hotels: updated,
      });

setHotelResults([]);

setHotelSearch(
  selectedHotel.name
);

setEditingHotel(false);

    };

  return (

    <Card
      size="small"
      style={{
        marginBottom: 18,
        borderRadius: 18,
        background: "#ffffff",
        border:
          "1px solid #edf2f7",
        boxShadow:
          "0 16px 40px rgba(15,23,42,0.08)",
      }}
    >

      <Row
        gutter={20}
        align="top"
      >

{/* IMAGE */}

<Col span={6}>

<Image
  src={
    hotel.image
      ? hotel.image.startsWith("http")
        ? hotel.image
        : `https://app.nestpedia.info${hotel.image}`
      : "https://placehold.co/600x500?text=Hotel"
  }

  height={240}

  width="100%"

  preview={false}

  fallback="https://placehold.co/600x500?text=Hotel"

  style={{

    objectFit: "cover",

    borderRadius: 18,
  }}
/>


        </Col>

        {/* CONTENT */}

        <Col span={18}>

          <Space
            direction="vertical"
            size={18}
            style={{
              width: "100%",
            }}
          >

{/* HEADER */}

<Row
  justify="space-between"
  align="middle"
>

  <Col flex={1}>

    {editingHotel ? (

      <AutoComplete
        style={{
          width: "100%",
        }}

        value={
          hotelSearch
        }

        options={
          (
            Array.isArray(
              hotelResults
            )

              ? hotelResults

              : []
          ).map((h) => ({

            value:
              h.name,

            label:
              `${h.name} • ${h.location?.city || ""}`,

            hotel: h,
          }))
        }

        onSearch={
          setHotelSearch
        }

        onSelect={(
          _,
          option
        ) =>
          changeHotel(
            option.hotel
          )
        }
      >

        <Input
          size="large"

          prefix={
            <SearchOutlined />
          }

          placeholder="Search hotel..."
        />

      </AutoComplete>

    ) : (

      <Space
        direction="vertical"
        size={2}
      >

        <Title
          level={3}
          style={{
            margin: 0,

            fontWeight: 800,

            color: "#0f172a",
          }}
        >
          {hotel.name}
        </Title>

        <Text type="secondary">
          {hotel.city}
        </Text>

      </Space>

    )}

  </Col>

  <Col>

    <Space>

      <Button
        icon={
          <SwapOutlined />
        }

        size="small"

        style={{
          borderRadius: 10,
        }}

        onClick={() =>
          setEditingHotel(
            !editingHotel
          )
        }
      >
        Change Hotel
      </Button>

      <Popconfirm
        title="Remove hotel?"
        okText="Remove"

        okButtonProps={{
          danger: true,
        }}

        onConfirm={
          removeHotel
        }
      >

        <Button
          danger

          size="small"

          style={{
            borderRadius: 10,
          }}

          icon={
            <DeleteOutlined />
          }
        >
          Remove
        </Button>

      </Popconfirm>

    </Space>

  </Col>

</Row>



{/* CONFIG */}

<Card
  size="small"
  style={{
    borderRadius: 14,
    background: "#fafcff",
    border: "1px solid #edf2f7",
  }}
>
  <Row gutter={[20, 18]} align="middle">

    {/* ROOM */}

    <Col xs={24} md={8} lg={5}>
      <Text strong>Room Type</Text>

      <Select
        value={hotel.roomType}
        style={{
          width: "100%",
          marginTop: 6,
        }}
        options={
          (hotel.roomOptions || [])

            .filter((room) => {

              const name =
                String(
                  room?.roomCategory || ""
                ).toLowerCase();

              return (
                name &&
                !name.includes("extra") &&
                !name.includes("adult") &&
                !name.includes("child") &&
                !name.includes("cwb") &&
                !name.includes("cnb")
              );
            })

            .map((room) => ({
              label: room.roomCategory,
              value: room.roomCategory,
            }))
        }
        onChange={(value) => {

          const room =
            hotel.roomOptions?.find(
              (r) =>
                r.roomCategory === value
            );

          const firstMeal =
            room?.mealPlans?.[0];

          const rates =
            firstMeal?.rates || {};

          updateHotel({

            roomType: value,

            roomCategory: value,

            mealOptions:
              room?.mealPlans || [],

            mealPlan:
              firstMeal?.mealPlan || "CP",

            basePrice:
              rates.baseRate || 0,

            extraAdultPrice:
              rates.extraAdultRate || 0,

            cwbPrice:
              rates.childWithBedRate || 0,

            cnbPrice:
              rates.childNoBedRate || 0,
          });
        }}
      />
    </Col>

    {/* MEAL */}

    <Col xs={12} md={8} lg={4}>
      <Text strong>Meal Plan</Text>

      <Select
        value={hotel.mealPlan}
        style={{
          width: "100%",
          marginTop: 6,
        }}
        options={
          hotel.mealOptions?.map(
            (meal) => ({
              label:
                meal.mealPlan,
              value:
                meal.mealPlan,
            })
          ) || []
        }
        onChange={(value) => {

          const rates =
            getHotelRate({
              hotel,
              roomType:
                hotel.roomType,
              mealPlan:
                value,
            });

          updateHotel({

            mealPlan: value,

            ...rates,
          });
        }}
      />
    </Col>

{/* ROOMS */}

<Col xs={12} md={8} lg={3}>

  <Text strong>
    Rooms
  </Text>

  <InputNumber
    min={1}

    style={{
      width: "100%",
      marginTop: 6,
    }}

    value={
      hotel.rooms || 1
    }

    onChange={(value) => {

      updateHotel({
        rooms: value || 1,
      });

    }}
  />

</Col>

    {/* NIGHTS */}

    <Col xs={12} md={8} lg={2}>
      <Text strong>Nights</Text>

      <InputNumber
        min={1}
        style={{
          width: "100%",
          marginTop: 6,
        }}
        value={
          hotel.nights
        }
        onChange={(value) => {

          const nights =
            value || 1;

          let checkOut =
            hotel.checkOut;

          if (hotel.checkIn) {

            const d =
              new Date(
                hotel.checkIn
              );

            d.setDate(
              d.getDate() +
              nights
            );

            checkOut =
              d.toISOString()
                .split("T")[0];
          }

          updateHotel({
            nights,
            checkOut,
          });
        }}
      />
    </Col>

    {/* CHECK IN */}

    <Col xs={12} md={12} lg={5}>
      <Text strong>Check In</Text>

      <Input
        type="date"
        value={
          hotel.checkIn || ""
        }
        style={{
          marginTop: 6,
        }}
        onChange={(e) => {

          const checkIn =
            e.target.value;

          let checkOut =
            hotel.checkOut;

          if (checkIn && hotel.nights) {

            const d =
              new Date(checkIn);

            d.setDate(
              d.getDate() +
              Number(hotel.nights || 1)
            );

            checkOut =
              d.toISOString()
                .split("T")[0];
          }

          updateHotel({
            checkIn,
            checkOut,
          });
        }}
      />
    </Col>

    {/* CHECK OUT */}

    <Col xs={12} md={12} lg={5}>
      <Text strong>Check Out</Text>

      <Input
        type="date"
        value={
          hotel.checkOut || ""
        }
        style={{
          marginTop: 6,
        }}
        onChange={(e) => {

          const checkOut =
            e.target.value;

          let nights =
            hotel.nights || 1;

          if (
            hotel.checkIn &&
            checkOut
          ) {

            const start =
              new Date(hotel.checkIn);

            const end =
              new Date(checkOut);

            const diff =
              Math.ceil(
                (
                  end - start
                ) /
                (1000 * 60 * 60 * 24)
              );

            nights =
              diff > 0
                ? diff
                : 1;
          }

          updateHotel({
            checkOut,
            nights,
          });
        }}
      />
    </Col>

  </Row>
</Card>



            {/* OCCUPANCY */}

            <Card
              size="small"
              style={{
                borderRadius: 14,
                background:
                   "linear-gradient(135deg,#ffffff,#f8fbff)",
                border:
                  "1px solid #edf2f7",
              }}
            >

              <Row gutter={16}>

                <Col span={6}>

                  <Text type="secondary">
                    Adults
                  </Text>

                  <InputNumber
                    min={1}
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.occupancy
                        ?.adults
                    }
                    onChange={(value) =>
                      updateHotel({
                        occupancy: {
                          ...hotel.occupancy,
                          adults:
                            value || 2,
                        },
                      })
                    }
                  />

                </Col>

<Col span={6}>

  <Text type="secondary">
    Extra Adult
  </Text>

  <InputNumber
    min={0}
    style={{
      width: "100%",
      marginTop: 6,
    }}
    value={
      hotel.occupancy
        ?.extraAdults || 0
    }
    onChange={(value) =>
      updateHotel({
        occupancy: {
          ...hotel.occupancy,
          extraAdults:
            value || 0,
        },
      })
    }
  />

</Col>

<Col span={6}>

                  <Text type="secondary">
                    CWB
                  </Text>

                  <InputNumber
                    min={0}
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.occupancy
                        ?.cwb
                    }
                    onChange={(value) =>
                      updateHotel({
                        occupancy: {
                          ...hotel.occupancy,
                          cwb:
                            value || 0,
                        },
                      })
                    }
                  />

                </Col>

                <Col span={6}>

                  <Text type="secondary">
                    CNB
                  </Text>

                  <InputNumber
                    min={0}
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.occupancy
                        ?.cnb
                    }
                    onChange={(value) =>
                      updateHotel({
                        occupancy: {
                          ...hotel.occupancy,
                          cnb:
                            value || 0,
                        },
                      })
                    }
                  />

                </Col>

              </Row>

            </Card>

            {/* PRICING */}

            <Card
              size="small"
              style={{
                borderRadius: 14,
                background:
                  "#fcfcfc",
                border:
                  "1px solid #f0f0f0",
              }}
            >

              <Row gutter={16}>

                <Col span={6}>

                  <Text type="secondary">
                    Base Rate
                  </Text>

                  <InputNumber
                    min={0}
                    prefix="₹"
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.basePrice
                    }
                    onChange={(value) =>
                      updateHotel({
                        basePrice:
                          value || 0,
                      })
                    }
                  />

                </Col>

                <Col span={6}>

                  <Text type="secondary">
                    Extra Adult
                  </Text>

                  <InputNumber
                    min={0}
                    prefix="₹"
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.extraAdultPrice
                    }
                    onChange={(value) =>
                      updateHotel({
                        extraAdultPrice:
                          value || 0,
                      })
                    }
                  />

                </Col>

                <Col span={6}>

                  <Text type="secondary">
                    CWB Price
                  </Text>

                  <InputNumber
                    min={0}
                    prefix="₹"
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.cwbPrice
                    }
                    onChange={(value) =>
                      updateHotel({
                        cwbPrice:
                          value || 0,
                      })
                    }
                  />

                </Col>

                <Col span={6}>

                  <Text type="secondary">
                    CNB Price
                  </Text>

                  <InputNumber
                    min={0}
                    prefix="₹"
                    style={{
                      width: "100%",
                      marginTop: 6,
                    }}
                    value={
                      hotel.cnbPrice
                    }
                    onChange={(value) =>
                      updateHotel({
                        cnbPrice:
                          value || 0,
                      })
                    }
                  />

                </Col>

              </Row>

            </Card>

            {/* TOTAL */}

            <Card
              size="small"
              style={{
                borderRadius: 16,
                background:
                 "linear-gradient(135deg,#ecfeff,#f0fdf4)",
                border:
                  "1px solid #b7eb8f",
              }}
            >

              <Row
                justify="space-between"
                align="middle"
              >

                <Col>

<Tag
  color="cyan"
  style={{

    borderRadius: 999,

    padding: "4px 12px",

    fontWeight: 700,
  }}
>
  HOTEL TOTAL
</Tag>

                  <Title
                    level={2}
                    style={{
                      margin: 0,
                    }}
                  >
                    ₹
                    {Number(
                      hotel.total || 0
                    ).toLocaleString()}
                  </Title>

                </Col>

                <Col span={6}>

                  <Text type="secondary">
                    Manual Override
                  </Text>


<InputNumber
  min={0}
  value={hotel.manualTotal}
  prefix="₹"
  style={{
    width: "100%",
    marginTop: 6,
  }}
  placeholder="Override total"
  onChange={(value) => {
    const manualTotal = Number(value ?? 0);

    updateHotel(
      {
        manualTotal,
        total: manualTotal,
        manualOverride: true,
      },
      true
    );
  }}
/>

                </Col>

              </Row>

            </Card>

          </Space>

        </Col>

      </Row>

    </Card>
  );
};

export default HotelCard;
